import { documentQueryKeys } from "./queryKeys"
import { useDocumentQuery } from "./useDocumentQuery"

export function useDocument(documentId, params = {}) {
    const url = `documents/${documentId}/`
    const queryKey = documentQueryKeys.detail(documentId, params)

    return useDocumentQuery(
        url,
        queryKey,
        params,
        {
            autoRefetch: true,
        },
    )
}

export function useDocuments(params = {}) {
    const url = "documents/"
    const queryKey = documentQueryKeys.list(params)

    return useDocumentQuery(
        url,
        queryKey,
        params,
        {
            autoRefetch: true,
        },
    )
}